import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from "../../components/landing/header";
import { Footer } from "../../components/landing/footer";
import "./GetStarted.css";
import { Image } from "react-bootstrap";
import HeroImage from "../../assets/images/services1.jpg";
import HowItWorksImage from "../../assets/images/landing_page/about-img.png";
import BenefitsImage from "../../assets/images/services3.jpg";

const GetStarted = () => {
  return (
    <div>
      <Header />

      {/* Hero Section */}
      <section className="section hero-section-getstarted">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="hero-content">
                <h1>Create Your 8112 Universal <span>Digital Coupon</span> Today</h1>
                <p className="hero-subtitle">
                  Launch, distribute, and track both digital and paper manufacturer coupons all from one easy-to-use platform. Starting at <span className="highlight-price">$65 for full access</span> to coupon creation tools.
                </p>
                <ul className="checklist">
                  <li>$65 — Coupon Creation Fee, one-time</li>
                  <li>$0.04 — Per Scan Fee, billed monthly</li>
                  <li>$0.01 — Coupon Bureau Fee per scan, billed monthly</li>
                </ul>
                <p className="hero-note">
                  Retailer reimbursement fees are processed and settled through your Coupon Bureau account.
                </p>
                <button className="theme-btn">Register Now</button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero-image">
                <Image src={HeroImage} alt="Coupon Hero" className="img-fluid rounded" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="section how-it-works-section">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-lg-6">
              <div className="how-it-works-image">
                <Image src={HowItWorksImage} alt="How It Works" className="img-fluid rounded" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="how-it-works-content">
                <h2>How <span>iClipCoupons</span> Works and How to Get Started</h2>
                <p className="section-intro">
                  In just a few simple steps, you'll create secure, B112-compliant digital coupons verified in real time through The Coupon Bureau's national network.
                </p>
                <h5 className="steps-heading">What You'll Need to Begin:</h5>

                <div className="step-item">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Register with the Coupon Bureau</h4>
                    <p className="step-description">
                      This verifies your brand and ensures your coupons meet official B112 compliance and redemption standards.
                    </p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>Select iClipCoupons as Your Solution Provider</h4>
                    <p className="step-description">
                      We handle all technical requirements — securely distributing serialized offer data to The Coupon Bureau's systems for real-time validation and redemption tracking.
                    </p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>Add Your Offer Details & Launch Your Coupon Campaign</h4>
                    <p className="step-description">
                      Build and launch your digital or paper coupons with iClipCoupons. Each offer is serialized, retailer-agnostic, verified in real time and tracked for redemption and performance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section benefits-section-getstarted">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="benefits-content">
                <h2>Benefit of Using <span>iClipCoupons</span></h2>
                <p className="section-intro">
                  A digital transformation that directly impacts sales and operational efficiency. iClipCoupons operates within The Coupon Bureau's national network of retailers and manufacturers, ensuring every offer you create meets official B112 standards for security and redemption.
                </p>

                <ul className="benefits-checklist">
                  <li>Meet Growing Consumer Demand for Digital Savings</li>
                  <li>Boost Product Sales and Build Customer Loyalty</li>
                  <li>Eliminate Coupon Fraud with Serialized Barcodes</li>
                  <li>Cut Costs on Coupon Printing & Distribution</li>
                </ul>

                <button className="theme-btn">Create Your Coupon Now</button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="benefits-image">
                <Image src={BenefitsImage} alt="Benefits" className="img-fluid rounded" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Book a Demo Section */}
      <section className="section book-demo-section-getstarted">
        <div className="container">
          <div className="demo-box">
            <div className="row">
              <div className="col-lg-5">
                <div className="demo-info">
                  <h2>Book a Demo to Get Started</h2>
                  <p>
                    Finding the best deals and keeping you connected effortlessly. We make digital coupons easy and rewarding.
                  </p>
                  <ul className="contact-list">
                    <li>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="white" strokeWidth="2"/>
                        <path d="M22 6L12 13L2 6" stroke="white" strokeWidth="2"/>
                      </svg>
                      <span>support@iclipcoupons.com</span>
                    </li>
                    <li>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="white" strokeWidth="2"/>
                        <circle cx="12" cy="10" r="3" stroke="white" strokeWidth="2"/>
                      </svg>
                      <span>242 Main Street, Ste #102 Beacon, New York 12508</span>
                    </li>
                    <li>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1469 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.27099 2.11999 4.18C2.095 3.90347 2.12787 3.62476 2.21649 3.36162C2.30512 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00026 4.10999 2H7.10999C7.59524 1.99522 8.06572 2.16708 8.43369 2.48353C8.80166 2.79999 9.04201 3.23945 9.10999 3.72C9.23662 4.68007 9.47144 5.62273 9.80999 6.53C9.94454 6.88792 9.97366 7.27691 9.8939 7.65088C9.81415 8.02485 9.62886 8.36811 9.35999 8.64L8.08999 9.91C9.51355 12.4135 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <span>(845) 326-7279</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-7">
                <form className="demo-form-getstarted">
                  <div className="row">
                    <div className="col-12 mb-3">
                      <input type="text" className="form-control" placeholder="Full name" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input type="email" className="form-control" placeholder="Email" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input type="tel" className="form-control" placeholder="Phone" required />
                    </div>
                    <div className="col-12 mb-3">
                      <textarea className="form-control" rows="4" placeholder="Message" required></textarea>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="theme-btn w-100">Submit Now</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GetStarted;
